import React from 'react';
import { useIntl } from 'react-intl';
import { Redirect, Route } from 'react-router-dom';
import useAuth from 'context/useAuth';
import PropTypes from 'prop-types';

import Footer from 'components/footer';
import Header from 'components/header/Header';
import { AppRoutes } from 'routes';

/**
 * @desc
 * PublicRoute's are available to access whether or not the user is signed in.
 * The route is wrapped with components that define the pages header and footer.
 */

const PublicRoute = ({ allowAuthenticatedUser, component: Component, ...rest }) => {
    const { user } = useAuth();
    const { formatMessage, locale } = useIntl();

    return (
        <div className="fairstone-retail-oam-app" id="oam-app">
            <Header />
            <main className="fairstone-retail-oam-app-content">
                <Route
                    {...rest}
                    render={(routeProps) => {
                        const { location } = routeProps;
                        return !allowAuthenticatedUser && user ? (
                            <Redirect
                                to={{
                                    pathname: `/${locale}` + formatMessage({ id: AppRoutes.accounts }),
                                    state: { from: location },
                                }}
                            />
                        ) : (
                            <Component {...routeProps} />
                        );
                    }}
                />
            </main>
            <Footer />
        </div>
    );
};

PublicRoute.defaultProps = {
    allowAuthenticatedUser: true,
};

PublicRoute.propTypes = {
    allowAuthenticatedUser: PropTypes.bool,
    component: PropTypes.elementType.isRequired,
};

export default PublicRoute;
